import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { formatDate, LOCAL_DATE_FORMAT_SHORT } from 'utils/date'

const styles = theme => ({
  root: {
    opacity: 1,
    zIndex: 9999,
    width: 'auto',
    borderRadius: 8,
    whiteSpace: 'nowrap',
    position: 'absolute',
    pointerEvents: 'none',
    padding: theme.spacing(1),
    animation: 'fadeIn .3s ease',
    transform: 'translate(-50%, -90px)',
    backgroundColor: theme.palette.white,
    '&:before': {
      width: 10,
      bottom: 0,
      height: 10,
      left: '50%',
      zIndex: 999,
      content: "'",
      position: 'absolute',
      backgroundColor: theme.palette.white,
      transform: 'translate(-50%, 4px) rotate(45deg)',
    },
    '& span': {
      fontWeight: 'bold',
    },
  },
})

class InfoTrapLabel extends React.Component {
  render() {
    const {
      classes, data, y, x
    } = this.props

    return (
      <div className={classes.root} style={{ top: y, left: x }}>
        <Typography>
          <span>Name</span> {data.trapName}
        </Typography>
        <Typography>
          <span>Kills</span> {data.totalKills}
        </Typography>
        <Typography>
          <span>Synced</span>{' '}
          {data.lastSynced
            ? formatDate(data.lastSynced, LOCAL_DATE_FORMAT_SHORT)
            : 'Never'}
        </Typography>
      </div>
    )
  }
}

InfoTrapLabel.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  data: PropTypes.object,
  classes: PropTypes.object,
}

export default withStyles(styles)(InfoTrapLabel)



// WEBPACK FOOTER //
// ./src/components/atoms/InfoTrapLabel.js